<companyid-content-wrapper classNames="flex-col py-80px mob:px-5 tab:px-5">
    <div class="flex justify-between mob:flex-col items-center mb-60px mob:gap-30px">
        <span class="text-h3-bold text-dark" i18n>
            Pain points &
            <br />
            <span class="text-secondary-color">Solutions</span>
        </span>
        <a i18n="@@button-try-it-now" class="button-black-outline mob:w-full" routerLink="/pricing">
            Try it Now
            <companyid-chevron color="black" position="right" content />
        </a>
    </div>
    <div class="flex flex-col w-full">
        @for (item of contentItems; let i = $index; track item.title) {
            <hr class="w-full border border-solid border-stroke mb-35px" />
            <div class="flex w-full gap-x-30px mb-35px">
                <img
                    [ngSrc]="item.imgPath | asset: 'home/pain-points-and-solutions'"
                    width="34"
                    height="35"
                    class="mob:hidden tab:hidden"
                    [alt]="item.imgPath"
                />
                <div class="flex flex-col w-full gap-2.5">
                    <span class="text-h6-semi-bold">{{ item.title }}</span>
                    <span class="text-dark text-medium-bold" i18n=":@@pain-point"
                        >Pain Point: <span class="text-medium-regular"> {{ item.subtitle }}. </span></span
                    >
                    <div
                        [ngClass]="[
                            'overflow-hidden transition-all duration-300 ease-in-out',
                            item.isShown ? 'max-h-96' : 'max-h-0',
                        ]"
                    >
                        <div class="rounded-xl border border-solid border-dark bg-secondary-color px-15px py-2.5">
                            <span class="text-white text-medium-bold" i18n=":@@solution"
                                >Solution: <span class="text-dark text-medium-regular">{{ item.solution }}.</span></span
                            >
                        </div>
                    </div>
                </div>
                <button
                    (click)="toggle(item)"
                    aria-label="View Solutions"
                    [class]="
                        ['button-white flex-row-reverse box-shadow-1', item.isShown ? 'active-blue-light' : '']
                            | joinClassNames
                    "
                >
                    <span class="mob:hidden tab:hidden" i18n>View Solutions</span>
                    <companyid-chevron
                        [color]="item.isShown ? 'blue' : 'black'"
                        [position]="item.isShown ? 'top' : 'bottom'"
                    />
                </button>
            </div>
        }
    </div>
    <img
        [ngSrc]="'vector' | asset: 'home/pain-points-and-solutions'"
        width="228"
        height="298"
        class="absolute right-0 bottom-[50px] mob:hidden tab:hidden hide-vector"
        alt="vector"
    />
</companyid-content-wrapper>
